// NOTE(jvoll): Though there was an old comment here saying that this file is
// deprecated and we should use `new VideoPlayerModel` directly instead, none
// of the code (outside of fixtures) currently does that so this is still
// very much alive and I don't think we'll be deprecating it anytime soon.
import type {MarkConversionT} from "@repo/analytics-learning-time";

import VideoPlayerModel from "./video-player-model.ts";

type VideoInfo = {
    // TODO(benkomalo): TypeScript was added after-the-fact. fill in.
    id: string;
    youtubeId: string;
};

type TopicInfo = {
    id: string;
};

function initializePlayerModel(
    video: VideoInfo,
    topic?: TopicInfo | null,
    markConversion?: MarkConversionT,
): typeof VideoPlayerModel {
    if (markConversion == null) {
        return new VideoPlayerModel({
            ...video,
            contentId: video.id,
            lessonID: topic && topic.id,
        });
    }
    return new VideoPlayerModel({
        ...video,
        contentId: video.id,
        lessonID: topic && topic.id,
        markConversion,
    });
}

export default initializePlayerModel;
